import {
    GET_ALL_CUSTOMER_PRODUCTS,
    GET_ALL_CUSTOMER_PRODUCTS_SUCCESS
} from "../actions/CustomerProducts.action";

const initialState = {
    getAllCustomerProductsLoading: false,
    allCustomerProducts: []
};
const RESET_LOADING="RESET_LOADING"

function branch(state = initialState, action) {
    switch (action.type) {
        case RESET_LOADING:
            return Object.assign({}, state, {
                getAllCustomerProductsLoading: false
            })

        case GET_ALL_CUSTOMER_PRODUCTS_SUCCESS:
            return Object.assign({}, state, {
                allCustomerProducts: action.payload.allCustomerProducts,
            })
        case GET_ALL_CUSTOMER_PRODUCTS:
            return Object.assign({}, state, {
                getAllCustomerProductsLoading: action.payload.getAllCustomerProductsLoading,
            })

        default:
            return state;
    }
}

export default branch;
